var include_top_information = `
<div class="top-news">
    <div class="contents-wrap pt60">
        <h3>お知らせ・ニュースリリース</h3>
        <div class="contents-wrap mt60">
            <div class="information mt60">
                <ul class="information__list">
                    <li class="information__list-item">
                        <a href="/information/mynumbercardpoint.html" class="information__link Nanaco_TopNews">
                            <p class="information__lead information__lead--only-text">「マイナポイント事業」に関する特設ページはこちら</p>
                        </a>
                    </li>
                    <li class="information__list-item">
                        <a href="/how-to/exchange_point/enemall.html" class="information__link Nanaco_TopNews">
                            <div class="information__inner">
                                <p class="information__date">2024年9月2日</p>
                                <div class="information__tag information__tag--info">お知らせ</div>
                            </div>
                            <p class="information__lead">北海道電力 エネモポイントからnanacoポイントへのポイント交換開始！</p>
                        </a>
                    </li>
                    <li class="information__list-item">
                        <a href="/how-to/save_point/sokuyaku.html" class="information__link Nanaco_TopNews">
                            <div class="information__inner">
                                <p class="information__date">2024年8月21日</p>
                                <div class="information__tag information__tag--info">お知らせ</div>
                            </div>
                            <p class="information__lead">SOKUYAKUとのポイント提携開始！</p>
                        </a>
                    </li>
                    <li class="information__list-item">
                        <a href="/information/typhoon2408.html" class="information__link Nanaco_TopNews">
                            <div class="information__inner">
                                <p class="information__date">2024年8月16日</p>
                                <div class="information__tag information__tag--info">お知らせ</div>
                            </div>
                            <p class="information__lead">台風に伴うnanacoお問合せセンターの受電対応について</p>
                        </a>
                    </li>
                    <li class="information__list-item">
                        <a href="https://www.e-map.ne.jp/p/nanaco/" class="information__link Nanaco_TopNews" target="_blank">
                            <div class="information__inner">
                                <p class="information__date">2024年8月15日</p>
                                <div class="information__tag information__tag--info">お知らせ</div>
                            </div>
                            <p class="information__lead">「nanacoが使えるお店検索」を更新しました(2024年7月末時点)</p>
                        </a>
                    </li>
                    <li class="information__list-item">
                        <a href="/material/pdf/release/pdf/2024/20240809.pdf" class="information__link Nanaco_TopNews" target="_blank">
                            <div class="information__inner">
                                <p class="information__date">2024年8月9日</p>
                                <div class="information__tag information__tag--news">ニュースリリース</div>
                            </div>
                            <p class="information__lead"><span class="information__lead-pdf">セブン‐イレブンアプリに登録したnanacoでお買い物するとnanacoポイント5倍キャンペーンのご案内</span></p>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="mt50 align-center">
            <div class="btn-link__wrap">
                <a href="/information/" class="btn-link btn-link--rainbow Nanaco_TopNews"><span class="btn-link__text">お知らせ・ニュースリリースを見る</span></a>
            </div>
        </div>
    </div>
</div>
`;
